class TabbedAffiliateContent extends HTMLElement {
  constructor() {
    super();
    this.tabs = [];
    this.panels = [];
    this.activeIndex = 0;
    this.mq = window.matchMedia('(min-width: 750px)');
  }

  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = this.tabs.map((tab) =>
      this.querySelector('#' + tab.getAttribute('aria-controls'))
    );
    if (!this.tabs.length) return;

    this.tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => {
        this.activate(i, true);
        tab.focus();
      });
      tab.addEventListener('keydown', (e) => this.onKey(e, i));
    });

    // In-editor: keep Shopify section events working. If admin opens a <details>
    // on mobile while tab mode is active, mirror that as a tab switch.
    this.panels.forEach((panel, i) => {
      if (!panel) return;
      panel.addEventListener('toggle', () => {
        if (this.mq.matches && panel.open && i !== this.activeIndex) {
          this.activate(i, true);
        }
      });
    });

    this.mq.addEventListener('change', () => this.syncMode());

    // Resolve initial tab: URL hash > data-default-tab > 0
    const hash = window.location.hash.replace('#', '');
    let initial = hash ? this.tabs.findIndex((t) => t.dataset.tabHandle === hash) : -1;
    if (initial < 0) initial = parseInt(this.dataset.defaultTab || '0', 10) || 0;
    if (initial >= this.tabs.length) initial = 0;

    this.syncMode();
    this.activate(initial, false);
  }

  syncMode() {
    const isDesktop = this.mq.matches;
    this.panels.forEach((panel) => {
      if (!panel) return;
      if (isDesktop) {
        panel.setAttribute('open', '');
      } else {
        panel.removeAttribute('open');
      }
    });
    this.classList.toggle('tabbed-affiliate--desktop', isDesktop);
  }

  activate(index, updateHash) {
    if (index < 0 || index >= this.tabs.length) return;
    this.activeIndex = index;
    this.tabs.forEach((tab, i) => {
      const active = i === index;
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.setAttribute('tabindex', active ? '0' : '-1');
      tab.classList.toggle('tabbed-affiliate__tab--active', active);
      const panel = this.panels[i];
      if (panel) panel.classList.toggle('tabbed-affiliate__panel--active', active);
    });

    if (updateHash) {
      const handle = this.tabs[index].dataset.tabHandle;
      if (handle) {
        history.replaceState(null, '', '#' + handle);
      }
    }
  }

  onKey(event, i) {
    const last = this.tabs.length - 1;
    let next = null;
    switch (event.key) {
      case 'ArrowRight':
        next = i === last ? 0 : i + 1;
        break;
      case 'ArrowLeft':
        next = i === 0 ? last : i - 1;
        break;
      case 'Home':
        next = 0;
        break;
      case 'End':
        next = last;
        break;
      default:
        return;
    }
    event.preventDefault();
    this.activate(next, true);
    this.tabs[next].focus();
  }
}

if (!customElements.get('tabbed-affiliate-content')) {
  customElements.define('tabbed-affiliate-content', TabbedAffiliateContent);
}
